// extracted by mini-css-extract-plugin
export default {"cta":"vG-z","disabled":"wG-z"};